export const basicSort = (a, b) => {
	if (typeof a === "number" && typeof b === "number") {
		return b - a;
	}

	if (typeof a === "string" && typeof b === "string") {
		if (a < b) {
			return -1;
		}

		if (a > b) {
			return 1;
		}

		return 0;
	}

	return 0;
};
